module.exports = __webpack_public_path__ + "static/media/Board of Studies_2020-21.4652739e.pdf";